let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("i2wZ7")).then(() => parcelRequire('9rrms'));